export function getWindowLocationPathname(): string {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.pathname || '/'
  }
  return ''
}
